import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getDemoLimitsHintShownSelector,
    getDemoLimitsUserHintSeenSelector,
} from '../../UserHints/userHintsSelectors';
import DemoLimitsHint from './DemoLimitsHint';
import GradientProgressBar from './GradientProgressBar';
import {
    getFreeOrdersLeftErrorSelector,
    getFreeOrdersLeftLoadingSelector,
    getFreeOrdersLeftSelector,
    getIsDemoLimitsAvailableSelector,
    getOrdersLimitSelector,
} from '../demoLimitsSelectors';
import { demoLimitsSlice } from '../demoLimitsReducer';
import useHintsInit from '../../UserHints/BuySellHint/hooks/useHintsInit';
import useEffectOnce from '../../../hooks/useEffectOnce';
import { useAbTestOption } from '../../AbTests/abTestsHooks';
import { AB_TESTS_NAMES } from '../../AbTests/abTestsConstants';

function DemoLimitsProgressInner() {
    const dispatch = useDispatch();
    const isDemoLimitsHintShown = useSelector(getDemoLimitsHintShownSelector);
    const freeOrdersLeftLoading = useSelector(getFreeOrdersLeftLoadingSelector);
    const freeOrdersLeftError = useSelector(getFreeOrdersLeftErrorSelector);
    const ordersLimit = useSelector(getOrdersLimitSelector);
    const freeOrdersLeft = useSelector(getFreeOrdersLeftSelector);
    const isDemoLimitsUserHintSeen = useSelector(getDemoLimitsUserHintSeenSelector);

    useEffectOnce(() => {
        dispatch(demoLimitsSlice.actions.getFreeOrdersLeftAction());
    });

    useHintsInit();

    if (freeOrdersLeftError) return null;
    if (freeOrdersLeftLoading) return <div className={'skeleton-br12'}/>;

    if (isDemoLimitsHintShown && !isDemoLimitsUserHintSeen) {
        return <DemoLimitsHint/>;
    }

    return <GradientProgressBar count={ordersLimit} activeCount={freeOrdersLeft}/>;
}

interface IDemoLimitsProgressProps {
    className?: string;
}

function DemoLimitsProgress({ className }: IDemoLimitsProgressProps) {
    const isDemoLimitsAvailable = useSelector(getIsDemoLimitsAvailableSelector);

    useAbTestOption(AB_TESTS_NAMES.DEMO_LIMITS);

    if (!isDemoLimitsAvailable) return null;

    return <div className={className}>
        <DemoLimitsProgressInner/>
    </div>;
}

export default memo(DemoLimitsProgress);
